const formatDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
}

export const getSelectedMonthDateRange = (financialYear, monthId) => {
    const month = Number(monthId)
    if (!month || month < 1 || month > 12) {
        return { fromDate: "", toDate: "" }
    }

    const years = String(financialYear || "").match(/\d{4}/g) || []
    const startYear = Number(years[0]) || new Date().getFullYear()
    const endYear = Number(years[1]) || startYear
    const calendarYear = years.length > 1 && month < 4 ? endYear : startYear
    const fromDate = new Date(calendarYear, month - 1, 1)
    const toDate = new Date(calendarYear, month, 0)

    return {
        fromDate: formatDate(fromDate),
        toDate: formatDate(toDate),
    }
}
